<template>
    <div>
        <Header/>
        <Nav :list="headerList"/>
        <div ref="content">
            <SingleBanner/>
            <div class="page-content">
                <div class="page-content-left">
                    <div class="page-content-left-title">{{aboutxiehuiObj.lishihui.title}}</div>
                    <div class="page-content-left-content" v-html="aboutxiehuiObj.lishihui.content"></div>
                </div>
                <div class="page-content-right">
                    <RightTab :list="arr"/>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
import RightTab from './components/rightTab.vue';
import { mapState } from 'vuex'
export default {
    computed: mapState([
        'aboutxiehuiObj'
    ]),
    components:{
       RightTab,
    },
    data() {
        return {
            headerList:[
                {name:'首页', href:'/'},
                {name:'关于协会', href:'/aboutISOC'},
                {name:'理事会成员', href:'/ifmDesc'},
            ],
            arr:[
                {name:'IFM简介',url:'/ifmDesc'},
                {name:'理事会成员',url:'/ifmLishihui'},
                {name:'IFM在中国',url:'/ifmInChina'},
                {name:'专家团队',url:'/grop'},
            ],
        }
    },
    mounted(){
    },
    methods: {
        
    },
}
</script>
<style lang="scss" scoped>
.news{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    .single{
        width: 580px;
    }
}
</style>
